import React, { useState, useCallback } from "react";
import { Box, Button, TextField } from "@mui/material";
import { motion } from "framer-motion";

export default function AnimatedFixed() {
  // Track sidebar state and dimensions
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSideBar, setIsSideBar] = useState(false);
  const [collapsedWidth, setCollapsedWidth] = useState(300);
  const [expandedWidth, setExpandedWidth] = useState(400);

  // Toggle sidebar expansion and sideBar state using useCallback for optimization
  const toggleExpansion = useCallback(() => setIsExpanded(prev => !prev), []);
  const toggleSideBar = useCallback(() => setIsSideBar(prev => !prev), []);

  // Calculate the width and translateX based on current state
  const sidebarWidth =  isExpanded ? expandedWidth : collapsedWidth;
  const translateX = isSideBar?-1* sidebarWidth : 0;

  return (
    <>
      {/* Inputs for adjusting collapsed and expanded widths */}
      <TextField
        label="Collapsed Width"
        type="number"
        value={collapsedWidth}
        onChange={(e) => setCollapsedWidth(Number(e.target.value))}
        sx={{ position: "absolute", top: "100px", left: "20px", zIndex: 10 }}
      />
      <TextField
        label="Expanded Width"
        type="number"
        value={expandedWidth}
        onChange={(e) => setExpandedWidth(Number(e.target.value))}
        sx={{ position: "absolute", top: "150px", left: "20px", zIndex: 10 }}
      />

      {/* Button to toggle sidebar expansion */}
      <Button
        variant="contained"
        onClick={toggleExpansion}
        sx={{ position: "absolute", top: "20px", left: "20px", zIndex: 10 }}
      >
        Toggle Expansion
      </Button>

      {/* Button to toggle sidebar appearance */}
      <Button
        variant="contained"
        onClick={toggleSideBar}
        sx={{ position: "absolute", top: "20px", left: "180px", zIndex: 10 }}
      >
        Toggle Sidebar
      </Button>

      {/* Animated Sidebar */}
      <motion.div
        animate={{
          translateX,
          width: sidebarWidth,
        }}
        transition={{
          type: "spring",
          stiffness: 100,
          damping: 20,
        }}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: sidebarWidth,
          height: "100vh",
          border: "1px solid black",
          // overflow: "hidden",
        }}
      >
        {/* Box component inside sidebar */}
        <Box
          sx={{
            position: "absolute",
            bottom: "10px",
            right: "-50px",
            width: "100px",
            height: "50px",
            backgroundColor: "blue",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Absolute
        </Box>
      </motion.div>
    </>
  );
}
